module.exports = __webpack_public_path__ + "img/1837a85.jpg";